import { registerLocaleData } from '@angular/common';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import localeLv from '@angular/common/locales/lv';
import {
  ApplicationConfig,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideRouter } from '@angular/router';

import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { csrfInterceptor } from '@core/csrftoken.interceptor';
import { ProfileService } from '@core/profile.service';

import { routes } from './app.routes';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (
  http: HttpClient,
) => new TranslateHttpLoader(http, './i18n/', '.json');

registerLocaleData(localeLv);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([csrfInterceptor])),
    provideAppInitializer(() => {
      const profileService = inject(ProfileService);
      return profileService.loadProfileData();
    }),

    provideTranslateService({
      defaultLanguage: 'lv',
      loader: {
        deps: [HttpClient],
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
      },
    }),
    { provide: MAT_DATE_LOCALE, useValue: 'lv' },
    { provide: LOCALE_ID, useValue: 'lv' },
  ],
};
